import {
  ChevronRight,
  Settings,
  LayoutGrid,
  Notebook,
  BuildingStore,
} from "tabler-icons-react";
import routeNames from "../../routes/routeNames";
export const adminData = [
  {
    icon: LayoutGrid,
    label: "Dashboard",
    // description: "Item with description",
    path: routeNames.admin.dashboard,
  },
  // {
  //   icon: BuildingStore,
  //   label: "User Roles",
  //   path: routeNames.admin.userRoles,
  // },
  {
    icon: Notebook,
    label: "Users",
    rightSection: <ChevronRight size={14} stroke={1.5} />,
    path: routeNames.admin.viewUsers,
  },
  //   subNav: [
  //     {
  //       label: "Job Seekers",
  //       path: routeNames.admin.viewJobSeekers,
  //     },
  //     {
  //       label: "Companies",
  //       path: routeNames.admin.viewCompanies,
  //     },
  //     {
  //       label: "Admins",
  //       path: routeNames.admin.viewAdmins,
  //     },
  //   ],
  // },
  // {
  //   label: "Categories",
  //   path: routeNames.admin.categories,
  // },

  // {
  //   hasDivider: true,
  //   header: "Jobs",
  //   label: "Jobs",
  //   path: "#",
  //   rightSection: <ChevronRight size={14} stroke={1.5} />,
  // },

  {
    hasDivider: true,
    header: "Jobs",
    label: "Industry Type",
    path: routeNames.admin.industryTypes,
  },
  {
    label: "Industries",
    path: routeNames.admin.industries,
  },
  {
    label: "Jobs",
    path: routeNames.admin.jobs,
  },

  // {
  //   hasDivider: true,
  //   header: "Job Seekers",
  //   label: "Job Seekers",
  //   path: "#",
  //   rightSection: <ChevronRight size={14} stroke={1.5} />,
  // },
  {
    hasDivider: true,
    header: "Job Seekers",
    label: "Profile Information",
    path: routeNames.admin.profileInformation,
  },
  // {
  //   label: "Employment History",
  //   path: routeNames.admin.employmentHistory,
  // },
  {
    label: "Education",
    path: routeNames.admin.education,
  },
  {
    label: "Skills & More",
    path: routeNames.admin.skillsAndMore,
  },
  // {
  //   label: "Profile Video",
  //   path: routeNames.admin.majors,
  // },
  {
    label: "Documents",
    path: routeNames.admin.documentLookups,
  },
  {
    label: "Web Links",
    path: routeNames.admin.webLinkLookups,
  },
  // {
  //   hasDivider: true,
  //   // header: "Job Seekers",
  //   label: "Skills",
  //   path: routeNames.admin.skills,
  // },
  // {
  //   label: "Degrees",
  //   path: routeNames.admin.degrees,
  // },
  // {
  //   label: "Interests",
  //   path: routeNames.admin.interests,
  // },
  // {
  //   label: "Majors",
  //   path: routeNames.admin.majors,
  // },

  // subNav: [
  //   {
  //     label: "Skills",
  //     path: routeNames.admin.skills,
  //   },
  //   {
  //     label: "Degrees",
  //     path: routeNames.admin.degrees,
  //   },
  //   {
  //     label: "Interests",
  //     path: routeNames.admin.interests,
  //   },
  //   {
  //     label: "Majors",
  //     path: routeNames.admin.majors,
  //   },
  // ],
  // },
  // {
  //   label: "Categories",
  //   path: routeNames.admin.categories,
  // },
  // },
  // {
  //   label: "Skills",
  //   path: routeNames.admin.skills,
  // },
  // {
  //   label: "Industries",
  //   rightSection: <ChevronRight size={14} stroke={1.5} />,
  //   path: "#",
  //   subNav: [
  //     {
  //       label: "Industry Type",
  //       path: routeNames.admin.industryTypes,
  //     },
  //     {
  //       label: "Industries",
  //       path: routeNames.admin.industries,
  //     },
  //   ],
  // },

  // {
  //   label: "Degrees",
  //   path: routeNames.admin.degrees,
  // },
  // {
  //   label: "Interests",
  //   path: routeNames.admin.interests,
  // },
  // {
  //   label: "Majors",
  //   path: routeNames.admin.majors,
  // },
  // {
  //   label: "Minors",
  //   path: routeNames.admin.minors,
  // },

  {
    hasDivider: true,
    icon: Notebook,
    label: "Lookups",
    path: routeNames.admin.lookups,
  },
  {
    hasDivider: true,
    header: "Settings and Support",
    icon: Settings,
    label: "Settings",
    path: routeNames.admin.editProfile,
  },
  {
    icon: Notebook,
    label: "FAQ's",
    rightSection: <ChevronRight size={14} stroke={1.5} />,
    path: "#",
    subNav: [
      {
        label: "FAQ Category",
        path: routeNames.admin.FAQCategory,
      },
      {
        label: "FAQs",
        path: routeNames.admin.FAQ,
      },
    ],
  },
];
